module.exports = __webpack_public_path__ + "static/img/app06.842dfe6.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app06.png
// module id = ob6M
// module chunks = 1